module.exports = __webpack_public_path__ + "fonts/VetoSansCond-Medium_1.ac12952e.woff2";